<template>
  <div class="col-md-4 pointer" v-if="data">
    <div class="p-4">
      <div class="row">
        <div class="col-12 mb-4">
          <div class="elevation-2 radius-5 box mx-auto px-3 pb-3 pointer">
            <div class="radius elevation-3 like-container" @click="setFavorite">
              <i
                class="fas fa-heart like"
                :class="{
                  'text-blue': data.userFavorite,
                  'text-gray': !data.userFavorite,
                }"
              />
            </div>
            <div class="row text-center" @click="$emit('openCard')">
              <div class="col-12 text-primary mt-4">
                <img :src="img && require(`@/assets/category/${img}.svg`)" />
              </div>
              <div class="col-12 font-weight-bold mt-2">
                Desafío {{ data.id }}
              </div>
              <div class="col-12 font-weight-bold text-logo mt-2">
                {{ data.nombre }}
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <div @click="showModal.ratingModal = true" style="z-index: 2;">
                  <i
                    class="fas fa-star text-secondary"
                    v-for="(item, i) in new Array(data.rating)"
                    :key="`checked-${i}`"
                  />
                  <i
                    class="fas fa-star text-gray"
                    v-for="(item, i) in new Array(5 - data.rating)"
                    :key="`unchecked-${i}`"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RatingModal
      :challengeData="data"
      v-if="showModal.ratingModal"
      @close="showModal.ratingModal = false"
      @setRating="setRating"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import RatingModal from "@/components/challenge/RatingModal";

export default {
  name: "ChallengeCard",
  components: {
    RatingModal,
  },
  props: ["cardData", "img"],
  data() {
    return {
      data: null,
      showModal: {
        ratingModal: false,
      },
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData"]),
  },
  methods: {
    async setFavorite() {
      let apiUrl = `${this.dataUrl}/testFavorite/addFavoriteTestToUser`;

      let method = "post";
      let params = [];
      if (this.data.userFavorite) {
        apiUrl = `${this.dataUrl}/testFavorite/deleteFavoriteTestToUser?userId=${this.teacherData.id}&testId=${this.data.id}`;
        method = "delete";
      }
      params.push(apiUrl);

      let apiData = {
        id: "",
        lbUserId: this.teacherData.id,
        desafio: {
          id: this.data.id,
        },
      };

      if (!this.data.userFavorite) params.push(apiData);
      let loader = this.$loading.show();

      try {
        let { data } = await this.axios[method](...params);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.data.userFavorite = !this.data.userFavorite;
          this.$notify({
            title: ["Cambio exitoso"],
            type: "success",
          });
        } else {
          this.$notify({
            title: ["Ocurrio un error"],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrio un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
    setRating(rating) {
      this.data.rating = rating;
      this.showModal.ratingModal = false;
    },
  },
  mounted() {
    this.data = this.cardData;
  },
};
</script>

<style lang="scss" scoped>
img {
  filter: invert(79%) sepia(66%) saturate(2442%) hue-rotate(348deg)
    brightness(102%) contrast(101%);
  max-height: 60px;
}

.box {
  height: 220px;
}

.like-container {
  padding: 6px 7px;
  background: white;
  margin-left: auto;
  margin-top: -18px;
  width: 45px;
  position: absolute;
  right: 0;
}

.like {
  font-size: 30px;
}

.icon {
  font-size: 60px;
}

p {
  font-size: 12px;
}
</style>
